import { render, staticRenderFns } from "./MdChips.vue?vue&type=template&id=51c0d810"
import script from "./MdChips.vue?vue&type=script&lang=js"
export * from "./MdChips.vue?vue&type=script&lang=js"
import style0 from "./MdChips.vue?vue&type=style&index=0&id=51c0d810&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports